export default __webpack_public_path__ + "static/media/storage-open-icon.440d866f.svg";